import { useFormContext } from "react-hook-form";
import { Box, Typography } from "@mui/material";
import { Moment } from "moment";

export default function InfoStep02() {

  const { getValues } = useFormContext()
  const { valores } = getValues()
  const isParcelado = valores.is_parcelado === 'true'
  const parcelas: TParcelas[] = valores.parcelas

  return (
    <>
      <Box display={'flex'} flexDirection={'column'} >

        <Box display={'flex'} gap={4}>
          <TableView
            title="Emissão"
            text={`${valores.data_emissao.format('DD/MM/YYYY')}`}
          />
          {
            !isParcelado &&
            <>
              <TableView
                title="Data de vencimento"
                text={`${valores.data_vencimento.format('DD/MM/YYYY')}`}
              />
            </>
          }
          <TableView
            title="Valor"
            text={`${valores.valor_total}`}
          />
        </Box>

        {
          isParcelado && parcelas.length > 0 &&
          <Typography variant="subtitle2" color="textSecondary">Parcelamento</Typography>
        }

        <Box overflow={'auto'} display={'flex'} maxHeight={280} flexDirection={'column'} flexWrap={'wrap'} gap={0}>
          {
            isParcelado && parcelas.length > 0 &&

            parcelas.map((item: TParcelas, index) => {
              return (
                <Typography mr={1} variant="subtitle1" key={index}>{item.numero_parcela}ª) {item.valor_parcela} ............ {item.data_vencimento.format('DD/MM/YYYY')}</Typography>
              )
            })
          }
        </Box>
      </Box>
    </>
  )
}

function TableView({ title, text }: TableViewProps) {
  return (
    <Box mb={1}>
      <Typography variant="subtitle2" color="textSecondary">
        {title}
      </Typography>
      <Typography variant="subtitle1">
        {text}
      </Typography>
    </Box>
  );
}

interface TableViewProps {
  title: string;
  text: string;
}

export type TParcelas = {
  valor_parcela: string,
  numero_parcela: number,
  data_vencimento: Moment
}